/*
  Cart-Drawer-Extras (urbanhive, UpCart-Ersatz)
  - Upsell-Quick-Add (delegiert, überlebt die Ajax-Re-Renders des Drawers)
  - Rabattcode einlösen/entfernen über /cart/update.js (Fallback: /discount/CODE)
  - Sticky-Cart-Button: Ausblenden bei leerem Warenkorb übernimmt CSS via :has()
*/
(function() {
  'use strict';

  var routes = (window.theme && theme.routes) || {};
  var cartUrl = routes.cart || '/cart.js';
  var cartAddUrl = routes.cartAdd || '/cart/add.js';
  var cartUpdateUrl = (routes.cartPage || '/cart') + '/update.js';
  var rootUrl = (routes.cartPage || '/cart').replace(/cart\/?$/, '');

  var strings = (window.theme && theme.strings) || {};

  function t(key, fallback) {
    return strings[key] || fallback;
  }

  function rebuildCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  /* == Upsell-Quick-Add ==================================================== */

  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('[data-upsell-add]');
    if (!btn) return;

    evt.preventDefault();
    if (btn.classList.contains('btn--loading')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) {
      var select = btn.parentNode.querySelector('[data-upsell-variant]');
      if (select) variantId = select.value;
    }
    if (!variantId) return;
    btn.classList.add('btn--loading');

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) {
          alert(data.description || data.message || 'Error');
        }
        rebuildCart();
      })
      .catch(function() {})
      .finally(function() { btn.classList.remove('btn--loading'); });
  });

  /* == Quick-Add auf Collection-Seiten: Drawer öffnen statt Cart-Page ====== */

  document.addEventListener('submit', function(evt) {
    var form = evt.target.closest('.grid-product__add-to-cart');
    if (!form) return;

    evt.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    if (btn) {
      if (btn.classList.contains('btn--loading')) return;
      btn.classList.add('btn--loading');
    }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status && data.status !== 200) {
          alert(data.description || data.message || 'Error');
          return;
        }
        // Motions CartDrawer hört darauf: baut den Warenkorb neu auf und öffnet den Drawer
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
      })
      .catch(function() {})
      .finally(function() { if (btn) btn.classList.remove('btn--loading'); });
  });

  /* == Artikel entfernen (Trash-Icon wie im UpCart-Original) =============== */

  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('[data-cart-remove]');
    if (!btn) return;

    evt.preventDefault();
    btn.disabled = true;

    fetch((routes.cartChange || '/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
    })
      .then(function(res) { return res.json(); })
      .then(function() { rebuildCart(); })
      .catch(function() { btn.disabled = false; });
  });

  /* == Upsell-Karussell: Pfeile links/rechts =============================== */

  document.addEventListener('click', function(evt) {
    var arrow = evt.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (!arrow) return;

    evt.preventDefault();
    var list = arrow.parentNode.querySelector('[data-upsell-list]');
    if (!list) return;

    var step = list.clientWidth;
    var maxScroll = list.scrollWidth - list.clientWidth;
    var next = arrow.hasAttribute('data-upsell-next');
    var target = list.scrollLeft + (next ? step : -step);

    // Am Ende wieder vorne starten und andersherum
    if (next && list.scrollLeft >= maxScroll - 4) target = 0;
    if (!next && list.scrollLeft <= 4) target = maxScroll;

    list.scrollTo({ left: target, behavior: 'smooth' });
  });

  // Autoplay: alle 5 s ein Produkt weiter, am Ende zurück zum Anfang
  setInterval(function() {
    document.querySelectorAll('[data-upsell-list]').forEach(function(list) {
      if (!list.clientWidth) return; // Drawer geschlossen
      var carousel = list.closest('.cart-upsells__carousel');
      if (carousel && carousel.matches(':hover')) return; // Nutzer interagiert gerade
      var maxScroll = list.scrollWidth - list.clientWidth;
      if (maxScroll <= 0) return;
      var target = list.scrollLeft >= maxScroll - 4 ? 0 : list.scrollLeft + list.clientWidth;
      list.scrollTo({ left: target, behavior: 'smooth' });
    });
  }, 5000);

  /* == Checkout-Button: Summe live mitführen =============================== */

  document.addEventListener('DOMContentLoaded', function() {
    var subtotal = document.querySelector('#CartDrawer [data-subtotal]');
    var checkoutTotal = document.querySelector('#CartDrawer [data-checkout-total]');
    if (!subtotal || !checkoutTotal) return;

    var sync = function() { checkoutTotal.textContent = subtotal.textContent; };
    new MutationObserver(sync).observe(subtotal, { childList: true, subtree: true, characterData: true });
    sync();
  });

  /* == Rabattcode ========================================================== */

  function discountRoot() {
    return document.querySelector('[data-cart-discount]');
  }

  function showMessage(text, isError) {
    var root = discountRoot();
    if (!root) return;
    var msg = root.querySelector('[data-discount-msg]');
    msg.textContent = text;
    msg.classList.remove('hide');
    msg.classList.toggle('cart-discount__msg--error', !!isError);
  }

  function clearMessage() {
    var root = discountRoot();
    if (!root) return;
    root.querySelector('[data-discount-msg]').classList.add('hide');
  }

  function renderAppliedCodes(codes) {
    var root = discountRoot();
    if (!root) return;
    var wrap = root.querySelector('[data-discount-applied]');
    wrap.innerHTML = '';
    codes.forEach(function(entry) {
      if (!entry.applicable) return;
      var chip = document.createElement('span');
      chip.className = 'cart-discount__chip';
      chip.innerHTML = '<span>' + entry.code + '</span>';
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-discount__remove';
      remove.setAttribute('aria-label', t('discountRemove', 'Entfernen') + ': ' + entry.code);
      remove.textContent = '×';
      remove.addEventListener('click', function() {
        var remaining = codes
          .filter(function(c) { return c.applicable && c.code !== entry.code; })
          .map(function(c) { return c.code; });
        updateDiscounts(remaining.join(','));
      });
      chip.appendChild(remove);
      wrap.appendChild(chip);
    });
  }

  function updateDiscounts(discountString, enteredCode) {
    var root = discountRoot();
    var applyBtn = root ? root.querySelector('[data-discount-apply]') : null;
    if (applyBtn) applyBtn.classList.add('btn--loading');

    fetch(cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: discountString })
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var codes = cart.discount_codes;

        if (!Array.isArray(codes)) {
          // Ältere API ohne discount_codes-Support: Code per Cookie für den
          // Checkout vormerken, im Warenkorb selbst ist er dann nicht sichtbar.
          if (enteredCode) {
            return fetch(rootUrl + 'discount/' + encodeURIComponent(enteredCode)).then(function() {
              showMessage(t('discountAtCheckout', 'Der Code wird im Checkout angewendet.'), false);
            });
          }
          return;
        }

        var inapplicable = codes.filter(function(c) { return !c.applicable; });

        if (enteredCode && inapplicable.some(function(c) { return c.code.toLowerCase() === enteredCode.toLowerCase(); })) {
          showMessage(t('discountInvalid', 'Dieser Code ist leider nicht gültig.'), true);
          // Ungültigen Code wieder entfernen, damit er nicht im Cart hängen bleibt
          var valid = codes.filter(function(c) { return c.applicable; }).map(function(c) { return c.code; });
          return fetch(cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: valid.join(',') })
          }).then(function() { renderAppliedCodes(codes.filter(function(c) { return c.applicable; })); });
        }

        if (enteredCode) {
          showMessage(t('discountApplied', 'Code eingelöst.'), false);
          var input = root.querySelector('[data-discount-input]');
          if (input) input.value = '';
        }
        renderAppliedCodes(codes);
      })
      .catch(function() {})
      .finally(function() {
        if (applyBtn) applyBtn.classList.remove('btn--loading');
        rebuildCart();
      });
  }

  function applyEnteredCode() {
    var root = discountRoot();
    if (!root) return;
    var input = root.querySelector('[data-discount-input]');
    var code = (input.value || '').trim();
    if (!code) return;
    clearMessage();

    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var existing = Array.isArray(cart.discount_codes)
          ? cart.discount_codes.filter(function(c) { return c.applicable; }).map(function(c) { return c.code; })
          : [];
        if (existing.indexOf(code) === -1) existing.push(code);
        updateDiscounts(existing.join(','), code);
      });
  }

  document.addEventListener('click', function(evt) {
    if (evt.target.closest('[data-discount-apply]')) {
      evt.preventDefault();
      applyEnteredCode();
    }
  });

  // Enter im Rabattfeld darf nicht das Checkout-Formular abschicken
  document.addEventListener('keydown', function(evt) {
    if (evt.key === 'Enter' && evt.target.matches('[data-discount-input]')) {
      evt.preventDefault();
      applyEnteredCode();
    }
  });

  // Bereits angewendete Codes beim Laden anzeigen
  document.addEventListener('DOMContentLoaded', function() {
    if (!discountRoot()) return;
    fetch(cartUrl, { headers: { Accept: 'application/json' } })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) {
          renderAppliedCodes(cart.discount_codes);
        }
      })
      .catch(function() {});
  });
})();
